<template>
	
	<div class="voucher-list" @click="event => {event.stopPropagation()}">
		<v-row v-if="search" class="mb-4">
			<v-col class="search-col">
				<v-text-field
					ref="search"
					v-model="query"
					prepend-inner-icon="mdi-magnify"
					density="compact"
					label="Search"
					variant="solo"
					:flat="true"
					hide-details
					clearable
					single-line
					bg-color="#eeeeee"
					@click="query=''"
					@blur="if (query == '') { query = null; }"
					@click:clear="onClear()"
				></v-text-field>
			</v-col>
		</v-row>
		<transition>
			<div class="voucher-list" v-if="normalizedVouchers">
				<div v-for="v in normalizedVouchers" :key="v.id">
					<a :href="navToVoucher ? '#/vouchers/amount/' + v.id : 'javascript:void(0)'" @click="navToVoucher ? null : handleVoucherClick(v)">
						<v-row :class="showSaving ? '' : 'mb-1'" class="d-flex">
							<v-col class="v-col-3 icon-col" style="">
								<img :src="v.cardUrl" :class="'icon ' + (showSaving ? 'mt-3' : 'mt-2')">
							</v-col>
							<v-col class="v-col-6 details-col">
								<span class="bold">{{v.merchant.name}}</span><br/>
								<span v-if="showDescription" class="description">{{ v.description }}</span>
								<div class="mt-1">
									<img v-if="v.online" src="@/assets/online.png" class="online-icon" />
									<img v-if="v.inStore" src="@/assets/inStore.png" class="in-store-icon" />
								</div>
								<div v-if="showSaving" class="spend-info">
									{{ spendLabel }} spend
									<strong>
										{{ formatter.format(Math.abs(showLastMonthSpend ? v.lastMonthSpend : v.spent)) }}
									</strong>
								</div>
							</v-col>
							<v-col v-if="!context" class="v-col-3 amount-col">
								<div class="vl"></div>
								<div>
									<FavoriteChip class="favouriteChip" v-if="showFavourites" :isFavorited="v.favourite" @favorite-clicked="toggleFavourite(v)" />
									<span class="label">{{ label }}</span><br/>
									<span v-if="v.totalVouchers" class="value">{{ v.totalVouchers }}</span>
									<span v-else class="value">{{ v.effectiveDiscountPercentage }}%</span><br/>
									<img v-if="!showSaving" class="discount-underline" src="../../assets/DiscountUnderline.png" />
									<div class="saving-info" v-if="showSaving">
										<strong>
											{{ formatter.format(
												showLastMonthSpend
													? Math.abs(v.lastMonthSpend * (v.effectiveDiscountPercentage / 100))
													: v.saving
											) }}
										</strong>
									</div>
								</div>
							</v-col>
						</v-row>
						<v-divider class="mt-2 mb-2"></v-divider>
					</a>
				</div>
			</div>
		</transition>
	</div>
	
</template>

<script>
import FavoriteChip from './FavoriteChip.vue';

export default {
	
	name: "VoucherList",
	components: {
		FavoriteChip
	},
	props: {
		search: {default: false},
		preSearch: {default: null},
		categories: {default: null},
		vouchers: {default: () => []},
		formatter: {default: null},
		today: {default: null},
		yesterday: {default: null},
		showAll: {default: false},
		showSaving: {default: false},
		spendLabel: {default: null},
		navToVoucher: {default: true},
		label: {default: "Save"},
		showFavourites: {default: false},
		showLastMonthSpend: {default: false},
		showDescription: {default: true}
	},
	data() {
		return{
			query: this.preSearch ?? null,
			context: false
		}
	},
	computed: {
		searchedVouchers() {
			var ret = [];
			if (this.query == null && !this.categories) {
				ret = this.showAll ? this.vouchers : null;
				this.$emit('onFilterApplied', ret ? ret.length : 0);
				return ret;
			}
			if (this.query == "" || this.query == null) {
				ret = this.vouchers;
			} else {
				ret = this.vouchers.filter(v => {
					const merchantName = v.merchant?.name || v.discount?.merchant?.name || '';
					return merchantName.toLowerCase().includes(this.query.toLowerCase());
				});
			}
			if (this.categories) {
				var toSearch = ret;
				ret = [];
				var cats = this.categories.split(",");
				cats.forEach(cat => {
					var found = toSearch.filter(v => {
						const categories = v.merchant?.categories || v.discount?.merchant?.categories || '';
						return categories.toLowerCase().includes(cat.toLowerCase());
					});
					found.forEach(f => {
						if (!ret.includes(f)) ret = [...ret, f];
					});
				});
			}
			this.$emit('onFilterApplied', ret.length);
			return ret;
		},
		normalizedVouchers() {
			return this.searchedVouchers?.map(v => {
				// Handle new structure with discount property
				if (v.discount) {
					return {
						id: v.discount.id,
						merchant: v.discount.merchant,
						cardUrl: v.discount.cardUrl,
						description: v.discount.description,
						online: v.discount.online,
						inStore: v.discount.inStore,
						stackWith: v.discount.stackWith,
						favourite: v.discount.favourite,
						effectiveDiscountPercentage: v.discount.effectiveDiscountPercentage,
						// Add the new totals
						totalVouchers: v.totalVouchers,
						totalAmount: v.totalAmount
					};
				}
				// Handle old structure (direct properties)
				return v;
			}) || [];
		}
	},
	methods: {
		onLoad() {
		},
		onClear() {
			this.$refs.search.blur();
		},
		toggleFavourite: function(v, event) {
			if (event) {
				event.stopPropagation();
				event.preventDefault();
			}
			this.$emit('favouriteToggled', v);
		},
		handleVoucherClick(v) {
			this.$emit('voucher-clicked', v);
		}
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

.label {
	text-align: left;
}

.favoriteChip {
	margin-right: -15px !important;
}

.chip-icon {
	height: 16px;
	width: 12px;
	margin: 0 auto;
}

.online-icon {
	height: 16px;
	width: 12px;
	margin: 0 auto;
}

.in-store-icon {
	height: 16px;
	width: 16px;
	margin: 0 auto;
}

.online-icon + .in-store-icon {
	margin-left: 5px;
}

.v-chip {
	margin-right: 5px;
	width: 25px;
	text-align: center;
	.v-icon{
		margin-left: -3px;
		text-align: center;
	}
}

.icon {
	width: 65px;
	background-color: #E7ECF7;
	border-radius: 10px;
}

.amount-col {
	vertical-align: center;
	position: relative;
	display: flex;
	align-items: center;
	img {
		width: 25px;
	}
}

.details-col {

	vertical-align: center;
	text-overflow: ellipsis;
	font-size: 14px;
}

.icon-col {
	vertical-align: middle;
}

.description {
	font-size: 12px;
	color: #555555;
	font-weight: lighter;
	display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.value {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
}

.search-col .v-text-field .v-field__clearable {
	display: block !important;
}

.spend-info {
	font-size: 13px;
	margin-top: 4px;
}

.saving-info {
	font-size: 11px;
	margin-top: 4px;
	background-color: #E0EBE3;
	border-radius: 4px;
	padding: 4px 8px 4px 8px;
	text-align: center;
}

.discount-underline {
	width: 50px !important;
	height: 5px !important;
	display: block;
	margin: 0 auto;
}

.vl {
	border-left: 0.5px solid rgba(0,0,0,0.2);
	align-self: stretch;
	margin-right: 15px;
}
</style>